import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	userReportBreadcrumb: {
		id: 'classic-software.rapidboard-content.breadcrumbs.user.user-report-breadcrumb',
		defaultMessage: 'Reports',
		description: 'Breadcrumb to reports in a user classic software project.',
	},
});
